var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.881,
    height: 7.487,
    viewBox: "0 0 14.881 7.487",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(0 7.487) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M2.246,7.44,7.189,1.807a1.084,1.084,0,0,0,.3-.823A1.045,1.045,0,0,0,7.1.212.891.891,0,0,0,5.836.318L.287,6.7a1.108,1.108,0,0,0,0,1.488l5.549,6.378a.891.891,0,0,0,1.259.106,1.046,1.046,0,0,0,.39-.771,1.084,1.084,0,0,0-.3-.823Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.f299b72ec9ccf57293193b4250eba8c6.svg";
export { ForwardRef as ReactComponent };